import Vue from 'vue'
import VueRouter from "vue-router";
import StandardList from "../views/StandardList.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'StandardList',
    component: StandardList
  }
]

const router = new VueRouter({
  routes,
  mode: "history"  ////修改路由模式为history,url不带#
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js